import React from "react";

import Box from "../Box";
import DeltaBadge from "../DeltaBadge";
import styled from "styled-components";
import { LayoutProps } from "styled-system";
import { CText } from "@carrefour/design-system-components-react";
import BaseDashboardCard from "../BaseDashboardCard";
import { useTranslation } from "react-i18next";
import { computeRHRate } from "../../utils/turnover";
import { formatKvalue, getCurrencySuffix } from "../../utils/numberUtils";
import { DriveTurnoverItem } from "../../types/drive";

type EcomBreakdownCardProps = {
  items?: DriveTurnoverItem[];
  pastItems?: DriveTurnoverItem[];
  importedDateTime?: string;
  isLoading: boolean;
  isUnavailable: boolean;
  openInformationModal: (title?: string) => void;
} & Pick<LayoutProps, "width">;

const Text = styled(CText)``;
const Table = styled.table`
  width: 100%;
  align-items: center;
`;
const Tr = styled.tr``;
const Th = styled.th<{ $textAlign?: string }>`
  text-align: ${(props) => props?.$textAlign};
`;
const Td = styled.td<{ $textAlign?: string }>`
  text-align: ${(props) => props?.$textAlign};
  padding-block: 8px;
`;

const EcomBreakdownCard = ({
  items,
  pastItems,
  isLoading,
  isUnavailable,
  ...res
}: EcomBreakdownCardProps) => {
  const { t } = useTranslation();

  const rows = [...(items ?? [])]
    .sort((a, b) => (b.turnover ?? 0) - (a.turnover ?? 0))
    .map((item) => {
      const pastTurnover = pastItems?.find(
        (pastItem) => pastItem.ecomServiceType === item.ecomServiceType
      )?.turnover as number;
      return {
        ecomServiceType: item.ecomServiceType,
        turnover: item.turnover,
        rate: computeRHRate(item.turnover, pastTurnover) as number,
      };
    });

  return (
    <BaseDashboardCard
      hasModal={true}
      {...res}
      title={t('ecommerce.repartition_ecommerce')}
      isLoading={isLoading}
      isUnavailable={isUnavailable || rows.length === 0}
      openInformationModal={() => null}
      size={"big"}
      width={"100%"}
    >
      <Box bg={"white"} width="100%" borderRadius={1} pt={1}>
        <Table>
          <thead>
            <Tr>
              <Th $textAlign={"left"}>
                <Text bold size={"S"} tagStyle={"p"}>
                  {t('ecommerce.categorie')}
                </Text>
              </Th>
              <Th $textAlign={"center"}>
                <Text bold size={"S"} tagStyle={"p"}>
                  {"vs "} {t('commercial.n_1')}
                </Text>
              </Th>
              <Th $textAlign={"right"}>
                <Text bold size={"S"} tagStyle={"p"}>
                  {t('commercial.ca')}
                </Text>
              </Th>
            </Tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <Tr key={row.ecomServiceType}>
                <Td $textAlign={"left"}>
                  <Text bold>{t(`ecommerce.service_type.${row.ecomServiceType}`)}</Text>
                </Td>
                <Td $textAlign={"center"}>
                  <DeltaBadge value={row.rate} />
                </Td>
                <Td $textAlign={"right"}>
                  <Text bold>
                    {row.turnover != null
                      ? `${formatKvalue(row.turnover, "")}${getCurrencySuffix(row.turnover)}`
                      : "-"}
                  </Text>
                </Td>
              </Tr>
            ))}
          </tbody>
        </Table>
      </Box>
    </BaseDashboardCard>
  );
};

export default EcomBreakdownCard;
